import { render, staticRenderFns } from "./MiniCartSlider.vue?vue&type=template&id=1417fe68&"
import script from "./MiniCartSlider.vue?vue&type=script&lang=js&"
export * from "./MiniCartSlider.vue?vue&type=script&lang=js&"
import style0 from "./MiniCartSlider.vue?vue&type=style&index=0&id=1417fe68&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductCardDefault: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/ProductCard/ProductCardDefault.vue').default})
